/**
 * ENV const khai báo những config sẽ luôn dùng trong các môi trường
 * */
export const envbase = {
   production: false,
   apiVersion: 2,
   language: {
      code: 'vi-VN',
      name: 'Vietnamese',
      availableLangs: [
         {
            id: 'vi-VN',
            label: 'Vietnamese'
         },
         {
            id: 'en-US',
            label: 'English'
         }
      ],
   },
   /** Tiền tố đường dẫn cho assets khi nhúng vào hệ thống khác (CRM/PHP) */
   assetsPrefix: '',

   // ------------------------------------------------------------------------------------------------------------------
   // Các config có thể thay đổi trong các môi trường ------------------------------------------------------------------
   // ------------------------------------------------------------------------------------------------------------------
   baseUrl: '',
   baseUrlApi: 'http://vpage.local:4211',
   cloudStorageStatic: {
      vpageStaticUrl: 'https://vpage.static.nvncdn.com/img/'
   },
   serverSSR: {
      PORT: 4001,
      USE_RENDERING: false,
   }
};
